import { render, staticRenderFns } from "./Api-chart.vue?vue&type=template&id=3aff1850&scoped=true&"
import script from "./Api-chart.vue?vue&type=script&lang=js&"
export * from "./Api-chart.vue?vue&type=script&lang=js&"
import style0 from "./Api-chart.vue?vue&type=style&index=0&id=3aff1850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff1850",
  null
  
)

export default component.exports